export const DEFAULT_COMPANY_CONFIG = {
	'name': 'World Care Elderly Centre Limited',
	'url': 'https://app.worldcareelderly.com',
	'logo': '/assets/img/logo.png',
	'bg': '/assets/img/bg.jpg'
};
